function domake(url, width, height) {
    var _url = '';
    var wxReg = /^(https\:\/\/|\/\/)wx\.qlogo\.cn/,
        imgReg = /^(https\:\/\/|\/\/)img\.58cdn\.com\.cn/,
        prefixPic = /^(https\:\/\/|\/\/)pic[1-8]/,
        prifexzzPic =  /^(https\:\/\/|\/\/)zzpic/;
    var re = /^(http\:)/;
		if(re.test(url)){
		   url = url.replace(re, "");
		}
    if (wxReg.test(url)) {
        _index = url.lastIndexOf('/');
        _url = url.substr(0, url.lastIndexOf('/')) + '/96';
        return _url;
    } else {
        if (imgReg.test(url)) {
            return url;
        }
        else if (prefixPic.test(url) || prifexzzPic.test(url)) {
            var reg = /_\d{2,}_\d{2,}\.(png$|jpg$|gif$)/;
            if(reg.test(url)){
                _url = url.split(url.match(reg)[0])[0];
            }else{
                _url = url;
            }
        }else if(/^http/.test(url)){
            return url
        }else {
            var random = Math.ceil(Math.random() * 8);
            _url = location.protocol + "//pic" + random + ".58cdn.com.cn/zhuanzh/" + url;
        }
        /*var dotIndex = _url.lastIndexOf('.');
        var suffix = _url.substr(dotIndex, _url.length - 1);
        var prefix = _url.split(suffix)[0];
        return prefix + '_' + width + '_' + height + suffix;*/
        return _url.replace(/(\.png|\.jpg)/ , "$1" + "?w="+width + "&h=" + height);

    }
}
exports.init = function (picUrl, width, height) {
    var typeofWidth = typeof width;
    var typeofHeight = typeof height;
    if (!picUrl) {
        picUrl = '//img.58cdn.com.cn/zhuanzhuan/images/default_head_icon.png';
        return picUrl;
    } else if ((typeofWidth !== 'string' && typeofWidth !== 'number') || (typeofHeight !== 'string' && typeofWidth !== 'number')) {
        width = 200;
        height = 200;
    }
    if (picUrl instanceof Array) {
        var newPicArr = [];
        picUrl.map(function (item, index) {
            newPicArr.push(domake(item, width, height));
        });
        return newPicArr;
    } else if (typeof picUrl == 'string') {
        return domake(picUrl, width, height);
    }
}
/**
* http协议转成成https协议的过滤器
* */
exports.formatHttps = function (url) {
	var re = /^(http)/;
  if(re.test(url)){
 	 return url.replace(re, "https");
  }
  return url
}



/** WEBPACK FOOTER **
 ** ./src/libs/adjustPic.js
 **/